import React from 'react';
import numberListHelper from '../utils/numberListHelper';

const componentClass = 'trackList';

const ContentTrackList = ({ tracks, onClick }) => {
    const listOfTracks = (tracks || []).map((t,i) => {
        const { title, artistsCredit, field_6: artistOverride } = t;
        const onTrackClick = () => {
            onClick && onClick(i);
        };
        return <li onClick={onTrackClick}>
            <div>{ numberListHelper(i + 1) }</div>
            <div className="trackList__trackInfo withPadding">
                <span>{ title }</span>
                <i>{ artistOverride || artistsCredit }</i>
            </div>
            { onClick && <span className="trackList__icon"><i className="fa fa-play-circle" /></span> }
        </li>
    });
    return <ul className={componentClass}>{listOfTracks}</ul>;
};

export default ContentTrackList;
